import Switch from '@material-ui/core/Switch';
import {Field} from 'formik';
import React from 'react';

const SwitchDefault = ({
  disabled,
  label,
  field,
  formikProps,
  myLabel,
}: SwitchProps) => {
  let useMyLabel = '';
  if (myLabel !== '#') {
    useMyLabel = myLabel;
  } else {
    useMyLabel = label;
  }
  return (
    <>
      <Field
        component={Switch}
        name={field}
        checked={formikProps.values[field]}
        onChange={(e: any) => {
          formikProps.setFieldValue(field, e.target.checked);
        }}
        disabled={disabled}
      />
      <p style={{display: 'inline'}}>{useMyLabel}</p>
    </>
  );
};

interface SwitchProps {
  disabled: boolean;
  type: string;
  label: string;
  field: string;
  formikProps: any;
  myLabel: string;
  fullWidth: boolean;
}

export default SwitchDefault;
